import { render } from "./TheMyCollectionModalWindow.vue?vue&type=template&id=26cbe3d9&scoped=true&ts=true"
import script from "./TheMyCollectionModalWindow.vue?vue&type=script&lang=ts"
export * from "./TheMyCollectionModalWindow.vue?vue&type=script&lang=ts"

import "./TheMyCollectionModalWindow.vue?vue&type=style&index=0&id=26cbe3d9&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26cbe3d9"]])

export default __exports__